export default "__VITE_ASSET__5b51b57f__"